module.exports = __webpack_public_path__ + "static/media/Icon-routine.a801260b.svg";